import { useSelector } from "react-redux"
import { selectIsShowUserList, selectIsTransferFinal, selectSearchValue, selectTransferOwnership } from "../../features/transfer-ownership/transfer-ownership-slice"
import { useMemo } from "react";
import { DropdownOption } from "../../features/auth/auth-state";

export const useTransferOwnershipDataState = () => {

    const transferOwnership = useSelector(selectTransferOwnership);
    const currentOwner = transferOwnership.currentOwner
    const newOwner = transferOwnership.newOwner

    const selectedProposals = transferOwnership.selectProposal

    const isShowUserList = useSelector(selectIsShowUserList);
    const isShowCurrentOwner = isShowUserList === 'currentOwner'
    const isShowNewOwner = isShowUserList === 'newOwner'

    const formattedCurrentOwner: DropdownOption = useMemo(() => ({
            id: currentOwner.id ?? 0,
            name: currentOwner.name,
            subTitle: currentOwner.email,
        }), [currentOwner.id, currentOwner.name, currentOwner.email]
    );
    const currentOwnerId = formattedCurrentOwner.id
    const currentOwnerEmail = formattedCurrentOwner.subTitle ?? ''
    const currentOwnerName = formattedCurrentOwner.name

    const formattedNewOwner: DropdownOption = useMemo(() => ({
            id: newOwner.id ?? 0,
            name: newOwner.name,
            subTitle: newOwner.email,
        }), [newOwner.id, newOwner.name, newOwner.email]
    );

    const newOwnerId = formattedNewOwner.id
    const newOwnerEmail = formattedNewOwner.subTitle ?? ''
    const newOwnerName = formattedNewOwner.name

    const ownershipSearchValue = useSelector(selectSearchValue)
    const isTransferFinal = useSelector(selectIsTransferFinal)

    return {
        transferOwnership,
        currentOwner: formattedCurrentOwner,
        formattedCurrentOwner,
        currentOwnerId,
        currentOwnerEmail,
        currentOwnerName,

        newOwner: formattedNewOwner,
        formattedNewOwner,
        newOwnerId,
        newOwnerEmail,
        newOwnerName,

        selectedProposals,

        isShowUserList,
        isShowCurrentOwner,
        isShowNewOwner,

        ownershipSearchValue,
        isTransferFinal,
    }
}


